import { createReducer } from 'redux-act';
import {
  fetchEventList,
  successFetchEventList,
  failFetchEventList,
} from '../actions/event';
//初期状態
const initial = {
  event: {
    items: undefined,
    isFetching: false,
    error: undefined,
  },
};

const event = createReducer(
  {
    [fetchEventList]: state =>
      Object.assign({}, state, {
        isFetching: true,
        error: undefined,
      }),
    [failFetchEventList]: (state, err) =>
      Object.assign({}, state, {
        isFetching: false,
        error: err,
      }),
    [successFetchEventList]: (state, payload) =>
      Object.assign({}, state, {
        isFetching: false,
        items: payload,
        error: undefined,
      }),
  },
  initial.event
);

export default event;



// WEBPACK FOOTER //
// ./src/reducers/event.js